/**
 * cart-compare-price.js
 * Injiziert Einführungsangebot-Badge und durchgestrichenen Preis im Warenkorb
 * für Produkte mit compare_at_price (Restaurant/Pflegeheim-Abos).
 *
 * Hintergrund: Shopify gibt compare_at_price für Subscription-Items (Selling Plans)
 * im cart.liquid Liquid-Kontext nicht zurück. Dieses Script lädt die Preise
 * direkt über die Storefront-API und injiziert sie clientseitig.
 */
(function() {
  'use strict';

  // Statisches Mapping: variant_id -> compare_at_price (in Cents)
  var COMPARE_PRICES = {
    "56722118377820": 27900,
    "56722120966492": 42900,
    "56722124177756": 72900,
    "56722119164252": 22900,
    "56722120474972": 42900,
    "57277170123100": 32900,
    "56722083414364": 72900,
    "56701024895324": 22900,
    "57277169402204": 42900,
    "56725532967260": 40900
  };

  // Badge-HTML identisch zur Produktseite (orange, pulsierend)
  var BADGE_STYLE = [
    'display:inline-flex',
    'align-items:center',
    'gap:6px',
    'background:linear-gradient(135deg,#f6ad55 0%,#ed8936 50%,#dd6b20 100%)',
    'color:#1a1a1a',
    'font-size:11px',
    'font-weight:800',
    'letter-spacing:0.08em',
    'text-transform:uppercase',
    'padding:5px 14px',
    'border-radius:20px',
    'margin-bottom:8px',
    'box-shadow:0 0 12px rgba(237,137,54,0.5),0 2px 8px rgba(0,0,0,0.3)',
    'animation:pulse-glow 2s ease-in-out infinite'
  ].join(';');

  var BADGE_HTML = '<div class="intro-offer-badge" style="' + BADGE_STYLE + '">Einf&uuml;hrungsangebot &nbsp;&middot;&nbsp; Nur f&uuml;r kurze Zeit</div>';

  var KEYFRAMES = '<style>@keyframes pulse-glow{0%,100%{box-shadow:0 0 12px rgba(237,137,54,0.5),0 2px 8px rgba(0,0,0,0.3)}50%{box-shadow:0 0 22px rgba(237,137,54,0.85),0 2px 8px rgba(0,0,0,0.3)}}</style>';

  function formatMoney(cents) {
    return '&euro;' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function injectComparePrices() {
    // Keyframes einmalig einfügen
    if (!document.querySelector('#cart-compare-keyframes')) {
      var styleEl = document.createElement('div');
      styleEl.id = 'cart-compare-keyframes';
      styleEl.innerHTML = KEYFRAMES;
      document.head.appendChild(styleEl.firstChild);
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cart.items.forEach(function(item) {
          var compareAtCents = COMPARE_PRICES[item.variant_id];
          if (!compareAtCents || compareAtCents <= item.price) return;

          // Finde das cart-item Element für dieses Produkt anhand des Titels
          var cartItems = document.querySelectorAll('.cart-item');
          cartItems.forEach(function(cartItem) {
            var h3 = cartItem.querySelector('h3');
            if (!h3 || h3.textContent.trim() !== item.product_title) return;

            var infoDiv = cartItem.querySelector('.cart-item-info');
            if (!infoDiv) return;

            // Prüfe ob Badge bereits vorhanden
            if (infoDiv.querySelector('.intro-offer-badge')) return;

            // Preis-Paragraph finden (enthält "pro Monat")
            var priceP = infoDiv.querySelector('p[style*="00d4ff"]');
            if (!priceP) return;

            // Badge + durchgestrichener Preis vor dem Preis-Paragraph einfügen
            var wrapper = document.createElement('div');
            wrapper.style.marginBottom = '6px';
            wrapper.innerHTML = BADGE_HTML + '<br><s style="text-decoration:line-through;color:#888;font-size:0.9em;">' + formatMoney(compareAtCents) + '</s>';
            infoDiv.insertBefore(wrapper, priceP);

            // Auch in der Preis-Spalte rechts (cart-item-price)
            var priceDiv = cartItem.querySelector('.cart-item-price');
            if (priceDiv && !priceDiv.querySelector('.compare-strike-right')) {
              var priceSpan = priceDiv.querySelector('.price');
              if (priceSpan) {
                var strikeRight = document.createElement('div');
                strikeRight.className = 'compare-strike-right';
                strikeRight.innerHTML = '<s style="text-decoration:line-through;color:#888;font-size:0.85em;display:block;margin-bottom:2px;">' + formatMoney(compareAtCents) + '</s>';
                priceDiv.insertBefore(strikeRight, priceSpan);
              }
            }
          });
        });
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectComparePrices);
  } else {
    injectComparePrices();
  }
})();
